/* import __COLOCATED_TEMPLATE__ from './conversation-attachments.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import type AppService from 'embercom/services/app-service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import type AttachmentSettings from 'embercom/models/attachment-settings';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import PredicateGroup from 'predicates/models/predicate-group';

interface Args {
  attachmentSettings: AttachmentSettings;
  settings: $TSFixMe;
  toggleUserAttachmentSettingsEnabled: () => void;
  onPredicatesChanged: () => void;
}

interface Signature {
  Args: Args;
}

export default class ConversationAttachments extends Component<Signature> {
  @tracked showRiskConfirmation = false;
  @service declare appService: AppService;
  @service declare attributeService: $TSFixMe;
  @service declare store: Store;

  initialPredicates: $TSFixMe;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    let raw = this.args.settings?.fileUploadAudiencePredicates ?? [];
    this.initialPredicates = (PredicateGroup as $TSFixMe).createPredicatesArray(this.store, raw);
  }

  @action
  handlePredicatesUpdate(predicates: $TSFixMe) {
    let serialized =
      typeof predicates?.serialize === 'function' ? predicates.serialize() : predicates;
    this.args.settings.set('fileUploadAudiencePredicates', serialized);
    this.args.onPredicatesChanged();
  }

  get userAttributes() {
    return this.attributeService.attributeGroupListForUsers;
  }

  @action
  toggleOtherFiles() {
    if (!this.args.attachmentSettings.allowedAttachmentFiletypesEnabled) {
      this.openOtherFilesModal();
    } else {
      this.args.attachmentSettings.set('allowedAttachmentFiletypesEnabled', false);
      this.args.attachmentSettings.set('allowedAttachmentFiletypesAgreedToRisk', false);
      this.args.attachmentSettings.set('allowedAttachmentFiletypesList', '');
    }
  }

  @action
  enableOtherFiles() {
    this.args.attachmentSettings.set('allowedAttachmentFiletypesEnabled', true);
    this.args.attachmentSettings.set('allowedAttachmentFiletypesAgreedToRisk', true);
    this.closeOtherFilesWarningModal();
  }

  @action
  openOtherFilesModal() {
    this.showRiskConfirmation = true;
  }

  @action
  cancelOtherFiles() {
    this.args.attachmentSettings.set('allowedAttachmentFiletypesEnabled', false);
    this.args.attachmentSettings.set('allowedAttachmentFiletypesAgreedToRisk', false);
    this.closeOtherFilesWarningModal();
  }

  @action
  closeOtherFilesWarningModal() {
    this.showRiskConfirmation = false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Security::Tabs::ConversationAttachments': typeof ConversationAttachments;
    'new-settings/workspace/security/tabs/conversation-attachments': typeof ConversationAttachments;
  }
}
